import * as React from "react";
import styled, { css } from "../../../styled/index";
import { CS } from "../../../styles/index";
import { FaPlus, FaMinus } from "react-icons/fa";
import lighten from "polished/lib/color/lighten";
import darken from "polished/lib/color/darken";
const Wrapper = styled("div") `
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  background: ${({ theme }) => theme.input.background};
  color: ${({ theme }) => theme.input.text};
  border: 1px solid ${({ theme }) => theme.input.border};
  border-radius: 3px;
  overflow: hidden;
  ${({ small, theme }) => small ? css `
    font-size: ${theme.input.fontSize - 2}px;
    height: 28px;
  ` : css `
    font-size: ${theme.input.fontSize}px;
    height: ${theme.input.height}px;
  `};
`;
const ControlCSS = css `
  ${CS.flex.center};
  cursor: pointer;
`;
const LeftControl = styled("div") `
  ${ControlCSS};
  width: ${({ small, theme }) => small ? 30 : theme.input.height}px;
  border-right: 1px solid ${({ theme }) => theme.input.border};
`;
const RightControl = styled("div") `
  ${ControlCSS};
  width: ${({ small, theme }) => small ? 30 : theme.input.height}px;
  border-left: 1px solid ${({ theme }) => theme.input.border};
`;
const Value = styled("div") `
  ${ControlCSS};
  width: ${({ small, theme }) => small ? 40 : theme.input.height + 10}px;
`;
export const BaseInputCSS = css `
  outline: 0;
  color: ${({ theme }) => theme.input.text};
  background-color: ${({ theme }) => theme.input.background};
  border: 0px solid ${({ theme }) => theme.input.border};
  font-size: ${({ theme }) => theme.input.fontSize}px;
  text-align: center;
  &:-moz-placeholder, &:-ms-input-placeholder, &::-moz-placeholder, &::-webkit-input-placeholder {
    color: ${({ theme }) => lighten(0.25, theme.input.text)};
  }
  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.primary};
  }
  &:disabled, &.disabled {
    background-color: ${({ theme }) => darken(0.10, theme.input.background)};
    cursor: not-allowed;
  }
`;
const InputComponent = styled("input") `
  width: ${({ small, theme }) => small ? 40 : theme.input.height + 10}px;
  ${BaseInputCSS};
`;
export const HitBox = (props) => {
    return (React.createElement(Wrapper, { className: "no-select", small: props.small },
        React.createElement(LeftControl, { onClick: props.down, small: props.small },
            React.createElement(FaMinus, null)),
        props.editable ?
            React.createElement(InputComponent, { value: props.value, max: 100, onChange: (e) => props.onChange && props.onChange(e.target.value) })
            : React.createElement(Value, { small: props.small }, props.value),
        React.createElement(RightControl, { onClick: props.up, small: props.small },
            React.createElement(FaPlus, null))));
};
//# sourceMappingURL=index.js.map